import axios from 'axios';
import { apiLogoutUrl } from '../config';

/**
 * GET Logout.
 *
 * @author Yves Matta <yves.matta@qochealth.com>
 * @param {{}} props
 * @param {{}} [props.requestConfig] - additional config for request
 * @returns {Promise}
 */
const logout = (props = {}) => {
  const { requestConfig } = props;

  const method = 'get';
  const url = apiLogoutUrl;

  return axios({
    method,
    url,
    ...requestConfig
  });
};

export default logout;



// WEBPACK FOOTER //
// ./src/qoc-sdk/library/logout.js